module.exports = __webpack_public_path__ + "static/media/Yashweb1.5480ebae.png";